import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="submit-button"
export default class extends Controller {
  connect() {
    this.resetOnPageRestore = ( event ) => {
      // Restore disabled buttons when the browser revives this page from back/forward cache.
      if( event.persisted ) this.resetButtons();
    };

    window.addEventListener( 'pageshow', this.resetOnPageRestore );
  }

  disconnect() {
    window.removeEventListener( 'pageshow', this.resetOnPageRestore );
  }

  submit( event ) {
    const button = this.submittedButton( event );

    if( !button ) return;

    // Match jquery-ujs: let the browser serialize the clicked submit button before disabling it.
    setTimeout( () => {
      if( !event.defaultPrevented ) this.disableButton( button );
    }, 13 );
  }

  submittedButton( event ) {
    if( this.hasSubmitText( event.submitter ) ) return event.submitter;

    const activeElement = document.activeElement;
    if( activeElement && activeElement.form === this.element && this.hasSubmitText( activeElement ) ) {
      return activeElement;
    }

    return this.element.querySelector(
      'button[data-submits-with], input[type="submit"][data-submits-with]'
    );
  }

  hasSubmitText( element ) {
    return element && element.dataset && Object.prototype.hasOwnProperty.call( element.dataset, 'submitsWith' );
  }

  disableButton( button ) {
    if( !button.dataset.originalText ) {
      button.dataset.originalText = this.buttonText( button );
    }

    this.setButtonText( button, button.dataset.submitsWith );
    button.disabled = true;
  }

  buttonText( button ) {
    return button.matches( 'input' ) ? button.value : button.innerHTML;
  }

  setButtonText( button, text ) {
    if( button.matches( 'input' ) ) {
      button.value = text;
    } else {
      button.innerHTML = text;
    }
  }

  resetButtons() {
    this.element.querySelectorAll( '[data-submits-with]' ).forEach( ( button ) => {
      this.resetButton( button );
    } );
  }

  resetButton( button ) {
    if( button.dataset.originalText ) {
      this.setButtonText( button, button.dataset.originalText );
    }

    button.disabled = false;
  }
}
